module.exports = __webpack_public_path__ + "fonts/Klamp-105-Mono-Bold.0e9ad12.otf";